import mutations from './supervisors.mutations'
import actions from './supervisors.actions'
import getters from './supervisors.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
